import { __extends } from "tslib";
import * as React from 'react';
import * as _scrollIntoView from 'scroll-into-view';
var scrollElementToView = function (element) {
    _scrollIntoView(element, {
        time: 500,
        align: { top: 0, left: 0.5 },
        validTarget: function (_, parentsScrolled) { return parentsScrolled < 1; }
    });
};
var ScrollAnchor = /** @class */ (function (_super) {
    __extends(ScrollAnchor, _super);
    function ScrollAnchor() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.scrollTargetElem = null;
        _this.setScrollTarget = function (elem) { return _this.scrollTargetElem = elem; };
        _this.scrollToTarget = function () {
            return !!_this.scrollTargetElem && scrollElementToView(_this.scrollTargetElem);
        };
        return _this;
    }
    ScrollAnchor.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.trigger !== this.props.trigger && nextProps.trigger === true) {
            this.scrollToTarget();
        }
    };
    ScrollAnchor.prototype.render = function () {
        return React.createElement("span", { ref: this.setScrollTarget });
    };
    return ScrollAnchor;
}(React.PureComponent));
export { ScrollAnchor };
//# sourceMappingURL=index.js.map